import {decorate, injectable} from '@yosmanyga/di';
import {ResourceLoader as BaseResourceLoader} from '@yosmanyga/base';

// import translations from '../assets/translations/all.json';

class TranslatorResourceLoader implements BaseResourceLoader {
    load = async () => {
        return {};
        // return translations;
        // return require(`../assets/translations/all.json`);
    };
}

decorate(injectable(), TranslatorResourceLoader);

export {TranslatorResourceLoader};
